import { render } from "./TraitRanksApesTraits.vue?vue&type=template&id=2be8eec0"
import script from "./TraitRanksApesTraits.vue?vue&type=script&lang=js"
export * from "./TraitRanksApesTraits.vue?vue&type=script&lang=js"

import "./TraitRanksApesTraits.vue?vue&type=style&index=0&id=2be8eec0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__